<svg  viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_623_83022)">
<path d="M16 32C24.826 32 31.9829 24.8536 32 16.0316V16L16 14L0 16C0 24.8366 7.16344 32 16 32Z" fill="#D80027"/>
<path d="M32 15.9684V16H0C0 7.16344 7.16344 0 16 0C24.826 0 31.9829 7.14638 32 15.9684Z" fill="#EEEEEE"/>
</g>
<defs>
<clipPath id="clip0_623_83022">
<rect fill="white"/>
</clipPath>
</defs>
</svg>
